import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './SeanceEditScreen';
import SeanceEdit from './SeanceEditScreen';
import { StoreState } from 'src/store/reducers';
//import { getSeance, deleteFileSeance, getFiles } from 'src/store/actions/seance-actions';
import { getSeance } from 'src/store/actions/seance-actions';

function mapStateToProps(state: StoreState): StateProps {
    return {
        seance: state.seances.current,
        inProgress: state.seances.inProgress,
        files: state.seances.currentFiles,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (id) => dispatch(getSeance(id)),
        //     getFiles: (id) => dispatch(getFiles(id)),

        //      removeFile: (id) => dispatch(deleteFileSeance(id)),
    };
}

const SeanceEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(SeanceEdit);

export default SeanceEditScreen;
